import { state } from "./state";
import * as actions from "./actions";
import * as rulesGetters from "./getters";
import * as baseGetters from "../baseGetters";
import * as mutations from "../baseMutations";

const getters = { ...rulesGetters, ...baseGetters };

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
